<script setup lang="ts">
const props = defineProps<{
  error: {
    statusCode?: number;
  };
}>();
</script>

<template>
  <NotFoundPage :status-code="props.error.statusCode || 404" />
</template>